import { useMutation } from "@tanstack/react-query";
import { journalsServiceApi } from "@/entities/api";

export const useBuildSignLinePartTwo = () =>
  useMutation<
    string,
    Error,
    {
      sectionFourListId: string;
      itemNoVersionId: string;
      itemPartTwoId: string;
      signerEmployeeId: string;
    }
  >({
    mutationFn: async ({
      sectionFourListId,
      itemNoVersionId,
      itemPartTwoId,
      signerEmployeeId,
    }) => {
      const token = localStorage.getItem("token");
      const res = await journalsServiceApi.post(
        `/journals/section-four/${sectionFourListId}/items/${itemNoVersionId}/itemPartTwo/${itemPartTwoId}/sign`,
        { signerEmployeeId },
        {
          responseType: "text",
          headers: {
            "X-Auth": token || "",
          },
        },
      );
      return res.data;
    },
  });

